var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.5963 8.56543H20.9808C19.51 11.462 18.398 14.4764 17.8176 17.5732C17.2298 20.7092 17.1872 23.9297 17.8691 27.1982H17.9077C18.2325 28.6805 18.8065 30.153 19.3767 31.6156C19.6209 32.2422 19.8645 32.8669 20.0874 33.4899H23.1841H23.1992H28.3476H28.3704H31.4821C31.7088 32.8566 31.958 32.2215 32.208 31.5845C32.778 30.1321 33.3518 28.67 33.67 27.1982H33.7081C34.2938 24.3905 34.3435 21.6181 33.9727 18.9043C33.4856 15.3394 32.2728 11.8755 30.5963 8.56543ZM25.7886 15.107C28.0069 15.107 29.8089 16.9165 29.8089 19.1349C29.8089 21.3532 28.0069 23.1552 25.7886 23.1552C23.5702 23.1552 21.7607 21.3532 21.7607 19.1349C21.7607 16.9089 23.5702 15.107 25.7886 15.107Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.874 6.71354H29.6951C29.6951 6.71354 27.2874 2.93997 25.7883 0.926025C24.2817 2.93997 21.874 6.71354 21.874 6.71354Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.1421 34.613L46.3888 37.3706C45.6691 31.215 35.6811 21.2198 35.6811 21.2198C36.4661 25.696 35.6229 30.1551 33.1421 34.613Z",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.3931 34.613L5.1464 37.3706C5.86601 31.215 15.854 21.2198 15.854 21.2198C15.069 25.696 15.9123 30.1551 18.3931 34.613Z",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.8678 35.2141L22.1126 40.7376C14.9392 37.3719 11.2151 44.1068 11.2151 44.1068C7.50499 42.214 3.02123 45.0457 3.61186 48.8464L47.9337 48.8767C48.6241 45.1062 44.0572 42.1913 40.3387 44.1068C40.3387 44.1068 36.4186 37.5686 29.3997 40.7982L27.6777 35.2141H23.8678Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.4a5ae7ef268d9d09e77943af73d3f1c8.svg";
export { ForwardRef as ReactComponent };